import * as ko from 'knockout';
import { GameRecordBase } from '../../shared/models/game-record-base';

/**
 * NHL GameRecord.
 * - toString() returns only win count (Points-based display).
 * - W+L denominator (no ties counted in denominator).
 */
export class NhlGameRecord extends GameRecordBase {
  constructor(fakeObs: KnockoutObservable<any>) {
    super(fakeObs, {
      includeTiesInDenominator: false,
      zeroGamesValue: 0,
      zeroPctValue: -1,
    });

    // Override toString to return only win count
    (this as any).toString = ko.computed(() => {
      return `${this.Wins()}`;
    });
  }

  protected override createToString(): string {
    return `${this.Wins()}`;
  }
}
